import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const AdPanel = styled.div`
  grid-area: ${props => props.$gridArea || '1 / 4 / 2 / 5'};
  background: url('/images/Armon/encart pub.png') no-repeat center top;
  background-size: cover;
  height: 566px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 432px;

  @media (max-width: 768px) {
    grid-area: auto;
    height: auto;
    min-height: 124vw;
    width: 100%;
  }
`;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 495px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 450px;
    width: 100%;
  }
`;

const Slide = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  opacity: ${props => props.$active ? 1 : 0};
  transition: opacity 0.5s ease-in-out;
`;

const AdContainer = ({ adImages, gridArea }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (adImages && adImages.length > 1) {
      const slideTimer = setInterval(() => {
        setCurrentSlide(current => 
          current === adImages.length - 1 ? 0 : current + 1
        );
      }, 6000);

      return () => clearInterval(slideTimer);
    }
  }, [adImages]);

  return (
    <AdPanel $gridArea={gridArea}>
      {adImages && adImages.length > 0 && (
        <SliderContainer>
          {adImages.map((image, index) => (
            <Slide
              key={index}
              src={image}
              alt={`Annonce ${index + 1}`}
              $active={index === currentSlide}
            />
          ))}
        </SliderContainer>
      )}
    </AdPanel>
  );
};

export default AdContainer; 